import store from '@/store';

const canI = (what = null) => {
  let userRole = store.state.auth?.user?.membership?.role;

  const access = ACCESS_PRIVILEGES[what] || null;
  if (!what || !access) throw new Error('Specify proper access string!');

  return access[userRole];
};

export default canI;

// The user can ... with role ...
export const ACCESS_PRIVILEGES = {
  editOwners: {
    owner: false,
    admin: false,
    regular: false,
  },
  editAdmins: {
    owner: true,
    admin: false,
    regular: false,
  },
  editRegulars: {
    owner: true,
    admin: true,
    regular: false,
  },
  inviteUsers: {
    owner: true,
    admin: true,
    regular: false,
  },
  createProjects: {
    owner: true,
    admin: true,
    regular: true,
  },
  dismissInvitation: {
    owner: true,
    admin: true,
    regular: false,
  },
};
